/* Scroll-driven section reveals: adds .is-revealed as sections enter the
   viewport. CSS (sinead.css motion system) handles the actual animation.
   Skipped entirely for reduced-motion users, the theme editor, and
   browsers without IntersectionObserver — content stays fully visible. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (document.documentElement.classList.contains('shopify-design-mode')) return;
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var sections = document.querySelectorAll('#MainContent .sinead-section');
    if (!sections.length) return;

    document.documentElement.classList.add('sy-reveal-ready');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      /* threshold must stay 0: a ratio threshold is unreachable for sections
         taller than ~12x the viewport (e.g. the testimonials grid), leaving
         them permanently hidden. The rootMargin already delays the reveal. */
      { rootMargin: '0px 0px -10% 0px', threshold: 0 }
    );

    sections.forEach(function (section) {
      section.classList.add('sy-reveal');

      var items = section.querySelectorAll(
        '.sinead-section__inner [class*="__grid"] > *, .sinead-trust-strip__badges > *'
      );
      items.forEach(function (item, index) {
        item.classList.add('sy-reveal-item');
        item.style.setProperty('--sy-reveal-i', Math.min(index, 8));
      });

      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
